
module.exports = ['$scope', 'User', '$ionicHistory', '$stateParams', 'Authenticator', '$utils', '$translate', '$state', '$timeout',
  '$sce', '$window', 'secondAuthService', '$q', '$loading',
  function ($scope, User, $ionicHistory, $stateParams, Authenticator, $utils, $translate, $state, $timeout,
    $sce, $window, secondAuthService, $q, $loading) {
    const userConfig = User.getCurrentUser().config || {}
    const authenticator = Authenticator.newAuthenticator({CUID: userConfig.email})
    $scope.email = $stateParams.email
    $scope.type = $stateParams.type

    init()
    function init() {
      const bindAccounts = authenticator.bindAccounts || []
      if ($scope.type == 'accountList' || ($scope.type == 'authcode' && bindAccounts.length == 1)) {
        $scope.showBackBtn = true
      }

      if ($stateParams.type == 'accountList') {
        setTimeout(function() {
          checkSecAuthInfo()
        }, 10)
      } else if ($stateParams.type == 'bind') { // 绑定验证
        $scope.isAuthBind = true
      } else if ($stateParams.type == 'direct') { // 二次验证直接授权
        handleDirectlyAuth()
      } else if ($stateParams.type == 'authcode') { // 验证码授权
        handleAuthCode()
      } else if ($stateParams.type == 'thirdParty') {
        handleThirdParty()
      }
    }

    // 显示授权码
    function handleAuthCode() {
      $scope.needAuthCode = true
      getDigitalCode()
    }

    // 直接授权
    function handleDirectlyAuth() {
      $scope.isAuthBind = false
      $scope.isDirectAuth = true
      const params = JSON.parse($stateParams.params || '')
      const trans = {
        'login': $translate.instant('OP.LOGIN'),
        'update_second_auth': $translate.instant('VERIFICATION.UPDATE_BIND_DEVICE'),
        'change_password': $translate.instant('OP.MODIFY_PWD')
      }
      $scope.operation = trans[params.trans]
    }

    function handleThirdParty() {
      $scope.isThirdParty = true
      const params = JSON.parse($stateParams.params || {})
      if (params.url) {
        $scope.thirdPartyUrl = $sce.trustAsResourceUrl(params.url || 'https://www.coremail.cn/')
      } else {
        $utils.$notify.set({message: $translate.instant('VERIFICATION.CANNOT_RECOGNIZE')})
        $scope.goBack()
      }
    }

    // 检测二次认证绑定信息
    function checkSecAuthInfo() {
      const deferred = $q.defer()
      const funValidateService = secondAuthService.querySecondAuth

      $loading.show()
      authenticator.validateAuthInfo(funValidateService).then(function (accounts) {
        console.log('update second auth info result is ' + JSON.stringify(accounts))
        $scope.allAccounts = accounts
        if (accounts.length == 0) {
          $scope.noBindAccounts = true
        } else if (accounts.length == 1) {
          $scope.type = 'authcode'
          $scope.email = accounts[0]
          $scope.showAllAccounts = false
          $scope.noBindAccounts = false
          handleAuthCode()
        } else {
          $scope.showAllAccounts = true
          $scope.noBindAccounts = false
        }
      }, function (error) {
        $scope.noBindAccounts = true
        deferred.reject(error)
      }).finally(function () {
        $loading.hide()
      })
      return deferred.promise
    }

    $scope.goBack = function () {
      if ($ionicHistory.backView()) {
        $ionicHistory.goBack()
      } else {
        $state.go('login')
      }
    }

    // 授权绑定账号
    $scope.secondAuthBind = function () {
      console.log($stateParams)
      const userAuthData = {}
      const authData = JSON.parse($stateParams.params || '')
      const options = {
        secret: authData.secret,
        uid: $scope.email,
        verifyCode: authenticator.getDigitalCodeBySecret(authData.secret)
      }
      userAuthData[$scope.email] = {Coremail: authData}

      $loading.show()
      authenticator.saveAuthData(userAuthData).then(function (data) {
        secondAuthService.updateSecondAuth(options).then(function (data) {
          // 绑定成功则把数据保存下来
          console.log('bindsuccess:' + JSON.stringify(data))
          $utils.$notify.set({message: $translate.instant('VERIFICATION.BIND_SUCCESSFUL')})
        }, function (error) {
          console.log(error, 'failed')
          const message = $translate.instant('VERIFICATION.BIND_FAILED') + $translate.instant('VERIFICATION.' + error.code)
          $utils.$notify.set({message: message})
          authenticator.removeAuthInfo($scope.email)
        })
      }, function (error) {
        $utils.$notify.set({message: JSON.stringify(error)})
      }).finally(function () {
        $loading.hide()
      })
    }

    //  直接授权
    $scope.toggleDirectAuth = function () {
      $scope.needAuthCode = !$scope.needAuthCode
    }

    $scope.validateSecondAuth = function () {
      const params = JSON.parse(($stateParams.params || {}) || '')
      const options = {
        tempSid: params.tempsid,
        trans: params.trans
      }
      $loading.show()
      authenticator.getDigitalCode($scope.email).then(function (digitalCode) {
        options.verifyCode = digitalCode
        secondAuthService.validateSecondAuth(options).then(function (data) {
          $scope.goBack()
          $utils.$notify.set({message: $translate.instant('VERIFICATION.AUTHORIZE_SUC')})
        }, function (error) {
          console.log('validateSecondAuth-error:' + JSON.stringify(error))
          const errorCode = error.data ? error.data.code : ''
          if (errorCode == 'FA_INVALID_SESSION' || errorCode == 'FA_INVALID_TEMP_SESSION') {
            $utils.$notify.set({message: $translate.instant('VERIFICATION.FA_INVALID_TEMP_SESSION')})
          }
        }).finally(function () {
          $loading.hide()
        })
      })
    }

    //  获取6位数验证码
    $scope.getDigitalCode = function () {
      getDigitalCode()
    }

    $scope.fNeedAuthCode = function () {
      $scope.needAuthCode = !$scope.needAuthCode
      if ($scope.needAuthCode && $stateParams.type == 'bind') { // 绑定需要先存码
        const params = {}
        params[$scope.email] = {Coremail: JSON.parse($stateParams.params || '')}
        console.log(params)
        authenticator.saveAuthData(params).then(function (data) {
          console.log('store suc')
          $scope.getDigitalCode()
        }, function (err) {
          console.log('store failed + :' + JSON.stringify(err))
          $utils.$notify.set({message: $translate.instant('获取失败')})
        })
        return
      }
      $scope.getDigitalCode()
    }

    function getDigitalCode() {
      authenticator.getDigitalCode($scope.email).then(function (digitalCode) {
        $scope.digitalCode = (digitalCode.toString()).split('')
        console.log('digitalCode: ' + digitalCode)
        $scope.timer = $timeout(getDigitalCode, 30000)
      }, function (_) {
        //
      })
    }

    $scope.$on('$destroy', function () {
      if ($scope.timer) {
        $timeout.cancel($scope.timer)
        console.log('timer has been canceled')
      }
    })
  }]



// WEBPACK FOOTER //
// ./src/js/verification/authCtrl.js